import { Show } from "solid-js";
import { spacedKey } from "../../boundaries/label.formatter";
import { formatDate, relativeAge } from "../../ui/format";
import type { MapPreviewSource } from "./mapPreviewModel";

export function MapSourceProvenance(props: {
  source: MapPreviewSource;
  compact?: boolean;
}) {
  return (
    <p
      class="map-source-provenance"
      classList={{ "is-compact": props.compact }}
    >
      <Show
        when={props.source.runId}
        keyed
        fallback={
          <>
            Source scan unavailable <span>·</span> {props.source.website}
          </>
        }
      >
        {(runId) => (
          <>
            Derived from {statusLabel(props.source.status)} scan{" "}
            <code title={runId}>{runId.slice(0, 8)}</code>
            <Show when={props.source.finishedAt} keyed>
              {(finishedAt) => (
                <>
                  <span>·</span>
                  <time
                    datetime={finishedAt.toISOString()}
                    title={formatDate(finishedAt)}
                  >
                    {formatDate(finishedAt)} ({relativeAge(finishedAt)})
                  </time>
                </>
              )}
            </Show>
            <span>·</span> {props.source.website}
          </>
        )}
      </Show>
    </p>
  );
}

function statusLabel(value: MapPreviewSource["status"]): string {
  if (!value) return "available";
  return spacedKey(value);
}
